import {enumType} from 'common/enumType';

export const RecurrenceType = enumType({
   NEVER: {id: 'NEVER', name: 'Never', noun: ''},
   DAILY: {id: 'DAILY', name: 'Daily', noun: 'days'},
   WEEKLY: {id: 'WEEKLY', name: 'Weekly', noun: 'weeks'},
   MONTHLY: {id: 'MONTHLY', name: 'Monthly', noun: 'months'},
   YEARLY: {id: 'YEARLY', name: 'Yearly', noun: 'years'},
});
